// extracted by mini-css-extract-plugin
export default {"container":"EditTradingPack_container__Dalf5"};